import MotivationElementNodeType from '../MotivationElementNodeType';
import {MOTIVATION_VALUE} from '../../metamodel/Concept';

export default class ValueNodeType extends MotivationElementNodeType {
	static get typeName() {
		return MOTIVATION_VALUE;
	}
}
